import _ from 'lodash';
import moment from 'moment';

export const checkIsMobile = () => {
    let check = false;
    const agent = navigator.userAgent || navigator.vendor || window.opera;
    // eslint-disable-next-line max-len
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\/|capi|ccwa|cdm\\-|cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|g1 u|g560|gene|gf\\-5|g\\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|i230|iac( |\\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\\-[a-w])|libw|lynx|m1\\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\/|se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|sk\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-/i.test(agent.substr(0, 4))) {
        check = true;
    }
    return check;
};

export const deepCopy = (object) => _.cloneDeep(object);

export const isJson = (json) => {
    try {
        JSON.parse(json);
        return true;
    } catch (error) {
        return false;
    }
};

export const isEmptyObject = (obj) => !!obj && Object.keys(obj).length === 0 && obj.constructor === Object;

export const compareObjects = (key, order = 'asc') => (a, b) => {
    if (!a[key] && !b[key]) {
        return 0;
    }
    if (!a[key] && a[key] !== 0) {
        return order === 'desc' ? 1 : -1;
    }
    if (!b[key] && b[key] !== 0) {
        return order === 'desc' ? -1 : 1;
    }
    const varA = (typeof a[key] === 'string') ?
        a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string') ?
        b[key].toUpperCase() : b[key];
    let comparison = 0;
    if (varA > varB) {
        comparison = 1;
    } else if (varA < varB) {
        comparison = -1;
    }
    return order === 'desc' ? comparison * -1 : comparison;
};

export const compareArrays = (arr1, arr2) => {
    if (!arr1 || !arr2) {
        return false;
    }
    if (arr1.length !== arr2.length) {
        return false;
    }
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
};

export const getSearchDates = (date, duration, dateTime = false) => {
    if (date?.length !== 2) {
        return [];
    }
    const [start, end] = date;
    const result = [];
    if (!duration) {
        result.push([
            formatDate(dateTime ? start : start.startOf('d')),
            formatDate(dateTime ? end : end.endOf('d'))
        ]);
        return result;
    }
    const diff = Math.ceil(moment(end).diff(start, duration, true)) || 1;
    for (let i = 0; i < diff; i += 1) {
        const startTime = moment(start).add(i, duration);
        const endTime = i < diff - 1 ? moment(start).add(i + 1, duration).subtract(1, 'd') : end;
        result.push([
            formatDate(dateTime ? start : startTime.startOf('d')),
            formatDate(dateTime ? end : endTime.endOf('d'))
        ]);
    }
    return result;
};

export const formatDate = (date, format = 'YYYY-MM-DDTHH:mm:ssZZ') => (date ? moment(date).format(format) : '');

export const momentDate = (date) => (date ? moment(date) : '');

export const momentTime = (time) => (time ? moment(`${moment().format('YYYY/MM/DD')} ${time}`) : '');

export const formatMinuteToDate = (minute) => {
    const d = Math.floor(minute / 1440);
    const h = Math.floor(minute % 1440 / 60);
    const m = minute % 1440 % 60;
    const list = [];
    if (d) {
        list.push(`${d} 天`);
    }
    if (h) {
        list.push(`${h} 時`);
    }
    if (m) {
        list.push(`${m} 分`);
    }
    return list.join(' ');
};

/**
 * 秒數轉為天時分
 * 規則如下：
 * 1. 如果有天，則應顯示時分，即便是 0
 * 2. 如果有時，則應顯示分，即便是 0
 * 3. 不需顯示秒
 * 4. 如果只有時，則不顯示天
 * 5. 如果只有分，則不顯示天/時
 */
export const formatSecondToHour = (seconds) => {
    const days = Math.floor(seconds / 86400);
    const remainingSecondsAfterDays = seconds % 86400;
    const hours = Math.floor(remainingSecondsAfterDays / 3600);
    const remainingSecondsAfterHours = remainingSecondsAfterDays % 3600;
    const minutes = Math.floor(remainingSecondsAfterHours / 60);
    const list = [];
    if (days) {
        list.push(`${days} 天`);
        list.push(`${hours} 時`);
        list.push(`${minutes} 分`);
    } else if (hours) {
        list.push(`${hours} 時`);
        list.push(`${minutes} 分`);
    } else if (minutes) {
        list.push(`${minutes} 分`);
    }
    return list.join(' ');
};

export const convertStringToHTML = (str) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    return doc.body.childNodes[0];
};

export const formatSelects = (selects) => {
    const result = selects.reduce((prev, curr) => {
        const { field: key, options } = curr;
        prev[key] = options.map((option) => ({
            value: option.value,
            label: option.description
        }));
        return prev;
    }, {});
    return result;
};

export const formatLogs = (data) => {
    const result = data
        .map((item) => {
            let newItem = { ...item };
            if (item.afterChanged) {
                const afterChanged = JSON.parse(item.afterChanged);
                if (afterChanged instanceof Array) {
                    newItem.afterChanged = afterChanged;
                } else {
                    newItem = {
                        ...item,
                        ...JSON.parse(item.afterChanged),
                        createTime: item.createTime,
                        createTimestamp: item.createTimestamp
                    };
                }
            }
            return newItem;
        })
        .sort(compareObjects('createTimestamp', 'desc'));
    return result;
};

export const getDirection = (direct) => {
    let result = typeof direct === 'number' ? '北' : '';
    if (direct >= 22.5 && direct < 67.5) {
        result = '東北';
    } else if (direct >= 67.5 && direct < 112.5) {
        result = '東';
    } else if (direct >= 112.5 && direct < 157.5) {
        result = '東南';
    } else if (direct >= 157.5 && direct < 202.5) {
        result = '南';
    } else if (direct >= 202.5 && direct < 247.5) {
        result = '西南';
    } else if (direct >= 247.5 && direct < 292.5) {
        result = '西';
    } else if (direct >= 292.5 && direct < 337.5) {
        result = '西北';
    }
    return result;
};

export const getDistance = (p1, p2) => {
    const { lat: lat1, lng: lng1 } = p1;
    const { lat: lat2, lng: lng2 } = p2;
    if (typeof lat1 !== 'number' || typeof lng1 !== 'number' ||
        typeof lat2 !== 'number' || typeof lng2 !== 'number'
    ) {
        return null;
    }
    if (lat1 === lat2 && lng1 === lng2) {
        return 0;
    }
    const lat1Rad = lat1 * Math.PI / 180;
    const lat2Rad = lat2 * Math.PI / 180;
    const lngRad = (lng1 - lng2) * Math.PI / 180;
    let dist = Math.sin(lat1Rad) * Math.sin(lat2Rad) + Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.cos(lngRad);
    if (dist > 1) {
        dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515 * 1.609344 * 1000;
    return dist;
};

// 判斷傳入的字串是否為 A-Z
const isUpperCaseAZ = (str) => {
    const regex = /^[A-Z]+$/;
    return regex.test(str);
};

/**
 * 將恣意租還的站點 key 轉成一般站點 id
 * 原本：["1-784", "1-783"]
 * 轉換：{ stationIds: [784, 783] }
 * 並將包含父分類的站點排除
 * 比如說選定中和區全部，那就不會儲存中和區底下的站點
 * 選定台北市全部，那就不會儲存台北市底下的站點&行政區
 * 選定全部站點，則返回全空的陣列
 */
export const getProcessedRentAnyPlaceStations = (stationKeys, regionToDistrictMap) => {
    if (!stationKeys) {
        return null;
    }
    if (stationKeys.some((key) => key === 'all')) {
        return {
            parentIds: [],
            stationIds: []
        };
    }

    // 填充縣市的 ignoreChildIds
    let ignoreChildIds = [];
    stationKeys.forEach((key) => {
        if (typeof key === 'string' && isUpperCaseAZ(key)) { // 縣市
            ignoreChildIds = [...ignoreChildIds, ...regionToDistrictMap[key].children];
        }
    });

    const parentIds = [];
    const stationIds = [...new Set(
        stationKeys
            .filter((key) => {
                if (typeof key === 'string' && isUpperCaseAZ(key)) { // 縣市
                    parentIds.push(regionToDistrictMap[key].id);
                    return false;
                }
                if (typeof key === 'number') { // 行政區/站點群組
                    if (ignoreChildIds.includes(key)) { // 已有上層的縣市，跳過
                        return false;
                    }
                    parentIds.push(key);
                    return false;
                }
                if (!key.includes('-')) {
                    return false;
                }
                const splitedKey = key.split('-');
                if (splitedKey.length === 3) { // 代表是縣市行政區
                    const city = splitedKey[0];
                    const cityId = regionToDistrictMap[city].id;
                    const cityCode = regionToDistrictMap[city].code;
                    if (stationKeys.includes(cityId) || stationKeys.includes(cityCode)) {
                        return false;
                    }
                }
                let parentId = splitedKey[0];
                if (splitedKey.length === 3) {
                    // eslint-disable-next-line prefer-destructuring
                    parentId = splitedKey[1];
                }
                if (stationKeys.includes(parseInt(parentId, 10))) {
                    return false;
                }
                return true;
            })
            .map((key) => {
                const splitedKey = key.split('-');
                if (splitedKey.length === 3) {
                    return parseInt(key.split('-')[2], 10);
                }
                return parseInt(key.split('-')[1], 10);
            })
    )]; // 篩選重複+處理

    return {
        parentIds,
        stationIds
    };
};

// 排除掉非數字的站點
export const getProcessedRentSameStations = (stationKeys) => stationKeys
    .filter((stationkey) => typeof stationkey === 'number');

export const filterUniqueByProperty = (array, key) => {
    const unique = new Map();
    array.forEach((item) => {
        if (!unique.has(item[key])) {
            unique.set(item[key], item);
        }
    });
    return Array.from(unique.values());
};

export const getYearStartEndDate = (year) => {
    const startTime = moment(`${year}-01-01 00:00:00`);
    const endTime = moment(`${year}-12-31 23:59:59`);
    return [startTime, endTime];
};

export const getYears = (minYear = 2020, maxYear = 2030) => {
    const result = [];
    for (let i = minYear; i <= maxYear; i += 1) {
        result.push({ value: i, label: i });
    }
    return result.reverse();
};

// 優惠碼兌換報表/優惠碼使用報表 用
export const getDateColumnName = (coupon) => {
    switch (coupon.couponType) {
        case 'REDEEM':
            return { start: 'redeemStartDate', end: 'redeemEndDate' };
        case 'CONDITION':
            return { start: 'conditionStartDate', end: 'conditionEndDate' };
        case 'ISSUE':
            return { start: 'publishTime', end: 'expirationDate' };
        default:
            return { start: '', end: '' };
    };
};
